import { render, staticRenderFns } from "./Semantics.html?vue&type=template&id=78aff5fa&scoped=true&"
import script from "./Semantics.vue?vue&type=script&lang=js&"
export * from "./Semantics.vue?vue&type=script&lang=js&"
import style0 from "./Semantics.vue?vue&type=style&index=0&id=78aff5fa&scoped=true&lang=css&"
import style1 from "./Semantics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aff5fa",
  null
  
)

export default component.exports